export const initStickyHeader = (win) => {
    const pageHeader = win.document.querySelector('#page-header')
    const plpHeader = win.document.querySelector('.product-listing-header')
    let lastScrollPosition = 0
    let scrollUpAmount = 0
    let isTicking = false

    // sanity check if header does not exist
    if (plpHeader === null || plpHeader === undefined || pageHeader === null || pageHeader === undefined) return

    const toggleHeaderVisibillity = () => {
        const windowOffset = window.pageYOffset || document.documentElement.scrollTop
        isTicking = false

        // Check if scroll up or down
        if (windowOffset > lastScrollPosition) {
            scrollUpAmount = 0
            // check if scroll down has cleared the header height
            if (windowOffset > pageHeader.offsetHeight) {
                plpHeader.classList.add('top-menu')
            }
        }
        else {
            scrollUpAmount += (lastScrollPosition - windowOffset)
            // check if scroll up has cleared the header height
            if (scrollUpAmount > pageHeader.offsetHeight) {
                plpHeader.classList.remove('top-menu')
            }
        }

        lastScrollPosition = windowOffset
    }

    const onScroll = () => {
        // Reference: https://css-tricks.com/debouncing-throttling-explained-examples/
        if (!isTicking) {
            requestAnimationFrame(toggleHeaderVisibillity)
        }
        isTicking = true
    }

    window.addEventListener('scroll', onScroll, false)
}